import React, { useState, useEffect } from "react";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
//Component
import { ReactTable } from "../../../stories/react-table";
import { Modal } from "../../../stories/modal";
import { getColumPlanDetail } from "../columns/popup-plan-detail";
import { getColumn } from "../columns/popup-daily-reprocess-detail";
import MuiRadio from "../../../stories/hook-controls/radio";
//Function
import * as api from "./../api";
import { Typography } from "@material-ui/core";
import { buildParameter } from "../parameter";
import { useSelectRowOpenModal } from "./../../function-api/useSelectRowOpenModal.js";
import * as alertDialog from "../../../utils/alert";
let { log: c } = console;
const holdOptions = [
  { label: "Hold", value: "1" },
  { label: "Unhold", value: "2" },
];

function HoldModal(props) {
  const methods = useForm();
  const { data, onClose } = props;
  async function Hold() {
    let param = buildParameter.HoldPlans(methods.getValues(), data);
    let res = await api.HoldPlans(param);
    if (!res) return;
    let arr_plan = res?.map((el) => el.PLAN_ID);
    let distinct_plan_id = [...new Set(arr_plan)];
    let old_sts = param.Hold ? "IDLE" : "HOLD";
    let new_sts = param.Hold ? "HOLD" : "IDLE";
    let txt =
      distinct_plan_id.length > 0
        ? `${distinct_plan_id.length} ${old_sts} plans successfully set to ${new_sts}`
        : `No ${old_sts} plans selected.`;
    await alertDialog.Inform(txt);
    onClose();
  }
  return (
    <>
      <FormProvider {...methods}>
        <Modal {...props} title={`Hold`} onSave={Hold}>
          {/* <Typography>{JSON.stringify(data)}</Typography> */}
          <Box display="block" bgcolor="background.paper">
            <MuiRadio
              name="hold"
              options={holdOptions}
              defaultValue={"1"}
            ></MuiRadio>
          </Box>
        </Modal>
      </FormProvider>
    </>
  );
}

export default HoldModal;
